module.exports = __webpack_public_path__ + "295d5f9ecb939a181408b2a5cd555d78.png";